import { IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import { useHistory } from "react-router-dom";
import { AssignmentOutlined } from "@mui/icons-material";
import { ITableColumn } from "../../../../App/Typings/Table";
import { useModalHooks } from "../../../../App/State/Hooks/useModalHooks";
import { ModalType } from "../../../../App/Enums/ModalType";
import { useDispatch } from "react-redux";
import { updateAdminState } from "../../../../App/State/Slices/AdminSlice";
import { IClient } from "../../../../App/Typings/Client";

const classes = {
  rowCell: {
    backgroundColor: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
    textAlign: "right",
  },
  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: "primary.copy",
    position: "relative",
    padding: "20px",
  },
};

interface IAbacUserTableCellProps {
  element: any;
  columns: ITableColumn[];
}

export default function UnassignClientTableCell({
  element,
  columns,
}: IAbacUserTableCellProps) {
  var tooltipText = "Assign Permissions for " + element.clientName;
  const dispatch = useDispatch();

  const { openModal } = useModalHooks();

  return (
    <>
      <TableRow hover key={element.id} sx={classes.rowCell}>
        {columns.map((column: ITableColumn, elementIndex: number) => {
          let value = element[column.propName];
          if (value instanceof Date) {
            value = value.toLocaleDateString("en-US");
          }
          return (
            <TableCell key={elementIndex} align="left" sx={classes.tableCell}>
              {column.label === "" ? (
                <Tooltip title={tooltipText}>
                  <IconButton
                    sx={{
                      position: "absolute",
                      right: "40px",
                      top: "10px",
                      border: "2px solid rgba(0,0,0,0.3)",
                    }}
                    onClick={(event) => {
                      event?.stopPropagation();
                      dispatch(
                        updateAdminState({ adminClient: element as IClient })
                      );
                      openModal({
                        open: true,
                        type: ModalType.AttributeAssignment,
                      });
                    }}
                  >
                    <AssignmentOutlined />
                  </IconButton>
                </Tooltip>
              ) : (
                value
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}
